<script setup lang="ts">
import { i18n } from '@apps/main/modules/localization/localizationSetup';
import { SemboBenefitsType } from '@apps/main/new-desktop/modules/semboBenefits';

import {
  SemboWalletIcon,
  SemboGuaranteeIcon,
  SemboCompassIcon,
  SemboMapIcon,
} from '@libs/ui';

import { HotelSelectionCardState } from '../models';

import HotelSelectionCardLayout from './HotelSelectionCardLayout.vue';

const { t } = i18n.global;

interface SemboBenefitsCardEmits {
  (event: 'benefit-clicked', value: SemboBenefitsType): void;
}
const emit = defineEmits<SemboBenefitsCardEmits>();

interface SemboBenefits {
  title: string;
  id: SemboBenefitsType;
}

const benefits: SemboBenefits[] = [
  {
    title: t('sembo_benefits.value_section.title'),
    id: SemboBenefitsType.Value,
  },
  {
    title: t('sembo_benefits.trust_section.title'),
    id: SemboBenefitsType.Trust,
  },
  {
    title: t('sembo_benefits.simplicity_section.title'),
    id: SemboBenefitsType.Simplicity,
  },
  {
    title: t('sembo_benefits.freedom_section.title'),
    id: SemboBenefitsType.Freedom,
  },
];
</script>

<template>
  <HotelSelectionCardLayout :card-state="HotelSelectionCardState.None">
    <template #sembo-benefits-card-title>
      <span class="title">{{ $t('sembo_benefits.title') }}</span>
    </template>
    <template #sembo-benefits-card-content>
      <button
        v-for="benefit in benefits"
        :key="benefit.id"
        class="sembo-benefit"
        @click="emit('benefit-clicked', benefit.id)"
      >
        <SemboWalletIcon
          v-if="benefit.id === SemboBenefitsType.Value"
          class="sembo-benefit-icon"
        />
        <SemboGuaranteeIcon
          v-if="benefit.id === SemboBenefitsType.Trust"
          class="sembo-benefit-icon"
        />
        <SemboMapIcon
          v-if="benefit.id === SemboBenefitsType.Simplicity"
          class="sembo-benefit-icon"
        />
        <SemboCompassIcon
          v-if="benefit.id === SemboBenefitsType.Freedom"
          class="sembo-benefit-icon"
        />
        <span class="sembo-benefit-title">{{ benefit.title }}</span>
      </button>
    </template>
  </HotelSelectionCardLayout>
</template>

<style scoped lang="scss">
.title {
  @include font-label-xxl-bold;
}

.sembo-benefit {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: var(--spacing-12);

  background-color: var(--color-white);
  border-radius: var(--border-radius-12);
  border: 1px solid var(--color-scrollbar);

  @include on-hover {
    cursor: pointer;
  }

  .sembo-benefit-icon {
    width: 30px;
    height: 32px;
  }

  .sembo-benefit-title {
    @include font-body-m-bold;
    color: var(--color-secondary-40);
    text-align: left;
  }
}
</style>
